import cloneDeep from 'lodash.clonedeep';
import uuid from 'uuid/v4';
import { canvasSizes } from 'JS/config/defaults';

export const PASTE_POSITION_OFFSET = 15;

const getOffsetPositions = (element, scribe, isSameScene, inPlace) => {
  const size = canvasSizes[scribe.canvasSize];
  const offset = !inPlace && isSameScene ? PASTE_POSITION_OFFSET : 0;

  const wouldPositionOffCanvasX = element.x + offset > size.width - offset;
  const wouldPositionOffCanvasY = element.y + offset > size.height - offset;

  return {
    x: wouldPositionOffCanvasX ? size.width - PASTE_POSITION_OFFSET : element.x + offset,
    y: wouldPositionOffCanvasY ? size.height - PASTE_POSITION_OFFSET : element.y + offset
  };
};

export default function pasteElementsIntoScribe(scribe, clipboard, activeElementIds, inPlace) {
  const clonedScribe = cloneDeep(scribe);
  const activeScene = clonedScribe.scenes.find(scene => scene.active);
  const pastePosition = activeElementIds?.length
    ? Math.max(...activeElementIds.map(elementId => activeScene.elementIds.findIndex(id => id === elementId))) + 1
    : activeScene.elementIds.length;
  const isSameScene = activeScene.id === clipboard.metadata.sceneId;

  const newElements = clipboard.data.map(element => {
    const newElement = {
      ...cloneDeep(element),
      id: uuid()
    };

    const { x, y } = getOffsetPositions(newElement, scribe, isSameScene, inPlace);
    newElement.x = x;
    newElement.y = y;

    return newElement;
  });
  const newElementIds = newElements.map(el => el.id);

  clonedScribe.elements = [...clonedScribe.elements, ...newElements];
  activeScene.elementIds.splice(pastePosition, 0, ...newElementIds);

  const elementClones = newElements.map(element => {
    const clone = cloneDeep(element);
    delete clone.id;
    return clone;
  });

  const clipboardPayload = {
    type: 'element',
    metadata: {
      sceneId: activeScene.id
    },
    data: elementClones
  };

  return { scribe: clonedScribe, newElementIds, clipboard: clipboardPayload };
}
